import React from 'react';
import './DarkMarketingPage.css';

const DarkMarketingPage = ({ history, title, subtitle, sections, quickTags }) => {
  return (
    <div className="dark-marketing-page">
      <section className="dmp-hero">
        <div className="dmp-wrap">
          <p className="dmp-eyebrow">Product page</p>
          <h1>{title}</h1>
          <p>{subtitle}</p>
          <button
            type="button"
            onClick={() => {
              history.push('/signup');
            }}
          >
            Start Building
          </button>
          {quickTags && quickTags.length > 0 ? (
            <div className="dmp-tags">
              {quickTags.map(tag => (
                <span key={tag}>{tag}</span>
              ))}
            </div>
          ) : null}
        </div>
      </section>

      <section className="dmp-sections">
        <div className="dmp-wrap">
          {sections.map((section, idx) => (
            <article
              className={`dmp-block ${section.reverse ? 'reverse' : ''} ${section.image ? '' : 'no-media'}`.trim()}
              key={`${section.title}-${idx}`}
            >
              <div className="dmp-copy">
                {section.label ? (
                  <div className="dmp-label">
                    {section.icon ? <img src={section.icon} alt="" /> : null}
                    <span>{section.label}</span>
                  </div>
                ) : null}
                <h2>{section.title}</h2>
                <p>{section.description}</p>
                <a href={section.link}>{'Learn More ->'}</a>
              </div>
              {section.image ? (
                <div className="dmp-media">
                  <img src={section.image} alt={section.title} />
                </div>
              ) : null}
            </article>
          ))}

          <section className="dmp-cta-strip">
            <div>
              <h3>Start crafting your website</h3>
              <p>Get a new experience with the most simple and easy builder on the internet right now.</p>
            </div>
            <button
              type="button"
              onClick={() => {
                history.push('/signup');
              }}
            >
              Start Building
            </button>
          </section>
        </div>
      </section>
    </div>
  );
};

export default DarkMarketingPage;
